import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FilterResumeResultsByDatePage } from './filter-resume-results-by-date.page';

const routes: Routes = [
  {
    path: '',
    component: FilterResumeResultsByDatePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FilterResumeResultsByDatePageRoutingModule {}
